import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import firebase from 'firebase/app';

var firebaseConfig = {
        apiKey: "AIzaSyAzn-Iu2Jt7htIMqD-gG_3TxUW84pI_eNY",
        authDomain: "ac-passport-quiz.firebaseapp.com",
        databaseURL: "https://ac-passport-quiz.firebaseio.com",
        projectId: "ac-passport-quiz",
        storageBucket: "ac-passport-quiz.appspot.com",
        messagingSenderId: "709737543957",
        appId: "1:709737543957:web:d68ec5ae06a9b42655d11c",
        measurementId: "G-J6R2QE8KHM"
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('root'));
